<template>
    <b-form-group :label="label">
        <multiselect
            :state="state"
            :selected="value"
            :options="options"
            :disabled="disabled"
            :loading="isLoading"
            :placeholder="placeholder"
            @changeValue="$emit('update:value', $event)"
            @click="getResearches()"
        />
    </b-form-group>
</template>
<script>
import i18n from '@/i18n'
import api from '@/services/api'
import { Multiselect, mapperToOptions } from '@/views/components/selects'
export default {
    name: 'EnpsResearches',
    components: {
        Multiselect,
    },
    props: {
        value: {
            type: Array,
            default: null,
        },
        state: {
            type: Boolean,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: i18n.t('enps.report.enpsResearch'),
        },
        lazyLoading: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
            default: i18n.t('form.placeholder.select'),
        },
    },
    data() {
        return {
            options: [],
            isLoading: false,
            isLoaded: false,
        }
    },
    watch: {
        options() {
            const option = this.options.find(option => {
                return option.value == this.$route.query.researchId
            })

            if (option != null) {
                this.$emit('update:value', [option])
            }
        },
    },
    mounted() {
        if (this.lazyLoading) {
            this.getResearches()
        }
        this.$emit('ready', true)
    },
    methods: {
        getResearches() {
            if (this.isLoaded) {
                return
            }

            this.isLoading = true
            api.get('/enps-researches', {
                params: {
                    filter: 'id;title',
                },
            })
                .then(resp => {
                    this.options = this.mapperEnpsResearchesToOptions(
                        resp.data.data
                    )
                    this.isLoaded = true
                })
                .catch(console.error)
                .finally(() => {
                    this.isLoading = false
                })
        },
        mapperEnpsResearchesToOptions(enpsResearches) {
            return mapperToOptions(enpsResearches, undefined, 'title')
        },
    },
}
</script>
